module.exports = function() {
  return new Worker(__webpack_public_path__ + "f1f4860438e1e592191c.worker.js");
};